module.exports = "data:image/webp;base64,UklGRkwAAABXRUJQVlA4IEAAAABQAwCdASoZABkAPpFCnEolo6KhqAgAsBIJZQC9/oAARVtYAAD+7qY/18ywpOf/6TZ/xNn/E2fJBZ3rft7wgAAA"


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/red.webp
// module id = IS9L
// module chunks = 14